const Routes = [
  {
    path: '/weekly-sales',
    name: 'WeeklySales',
    component: () => import('@/app/weekly_sales/TheWeeklySales'),
    redirect: '/weekly-sales/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/weekly-sales/',
        component: () => import('@/app/weekly_sales/views/Index'),
        name: 'Index',
        redirect: '/weekly-sales/annual-comparative',
        children: [
          {
            path: 'annual-comparative',
            component: () => import('@/app/weekly_sales/views/AnnualComparative'),
            name: 'AnnualComparative'
          },
          {
            path: 'weekly-comparative',
            component: () => import('@/app/weekly_sales/views/WeeklyComparative'),
            name: 'WeeklyComparative'
          }
        ]
      },
      {
        path: 'annual-comparative/week/:year/:week',
        component: () => import('@/app/weekly_sales/views/WeeklyDetailGrid'),
        name: 'WeeklyDetailGrid',
        props: route => ({
          week: route.params.week,
          year: parseInt(route.params.year)
        })
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/weekly_sales/Routes.js